import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, Loader2, PackageSearch } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, STATUS_LABELS, STATUS_STYLES } from "../lib/api";
import { TrackingTimeline } from "../components/TrackingTimeline";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function TrackOrder() {
  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.post("/track", { order_id: orderId.trim(), email: email.trim() });
      setResult(data);
    } catch (err) {
      toast.error(apiError(err, "Aucune commande ne correspond à ces informations"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl px-6 py-14" data-testid="track-page">
      <div className="text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50 text-ciel">
          <PackageSearch size={22} />
        </span>
        <h1 className="mt-4 font-display text-2xl font-bold tracking-tight text-navy md:text-3xl">Suivre ma commande</h1>
        <p className="mt-2 text-sm text-slate-500">
          Sans compte : renseignez votre numéro de commande (ex : VS-AB12CD34) et l'email utilisé lors de l'achat.
        </p>
      </div>

      <form onSubmit={submit} className="mt-8 space-y-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="track-form">
        <div>
          <label className="text-sm font-medium text-slate-700">Numéro de commande</label>
          <Input data-testid="track-order-input" required value={orderId} placeholder="VS-XXXXXXXX"
            onChange={(e) => setOrderId(e.target.value.toUpperCase())} className="mt-1.5 font-mono uppercase" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Email d'achat</label>
          <Input data-testid="track-email-input" type="email" required value={email} placeholder="vous@exemple.com"
            onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
        </div>
        <Button data-testid="track-submit" disabled={loading} className="w-full rounded-full bg-ciel py-5 text-sm font-semibold text-white hover:bg-sky-700">
          {loading ? <Loader2 className="animate-spin" size={16} /> : <><Search size={15} className="mr-2" /> Rechercher ma commande</>}
        </Button>
      </form>

      {result && (
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="track-result">
          <div className="flex items-center justify-between">
            <p className="font-mono text-sm font-semibold text-navy">{result.order_id}</p>
            <span className={`rounded-full border px-3 py-1 text-[11px] font-semibold ${STATUS_STYLES[result.status]}`} data-testid="track-status">
              {STATUS_LABELS[result.status]}
            </span>
          </div>
          <div className="mt-4">
            <TrackingTimeline events={result.events} />
          </div>
          <p className="mt-6 border-t border-slate-100 pt-4 text-xs text-slate-400">
            Un compte vous donne accès aux téléchargements, au streaming et à la facture.{" "}
            <Link to="/auth" className="font-semibold text-ciel hover:underline">Créer un compte</Link>
          </p>
        </div>
      )}
    </div>
  );
}
